import { t } from "i18next";
import { useEffect } from "react";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { ShareCodeService } from "../services/ShareCodeService";
import { ERROR, useNotification } from "./CustomHooks/NotificationProvider";

const Share = () => {
  const showNotification = useNotification();
  let { tenantId, shareId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    ShareCodeService.getExternalShareCode(`${tenantId}/${shareId}`, true)
      .then((sharePayload) => {
        let redirectPath = sharePayload.payload.shared_path;
        if (sharePayload.payload.shared_path === "/rater") {
          let state = {
            state: {
              purl_id: sharePayload.payload.context.purl_id,
              term_id: sharePayload.payload.context.term_id,
              assessment_id: sharePayload.payload.context.assessment_id,
              assignment_id: sharePayload.payload.context.assignment_id,
              token: sharePayload.token,
              share_id: shareId,
            },
          };
          return navigate(redirectPath, state);
        } else if (
          sharePayload.payload.shared_path === "/external-assessment"
        ) {
          let state = {
            state: {
              purl_id: sharePayload.payload.context.purl_id,
              term_id: sharePayload.payload.context.term_id,
              assessment_id: sharePayload.payload.context.assessment_id,
              assignment_id: sharePayload.payload.context.assignment_id,
              token: sharePayload.token,
              share_id: shareId,
              assessment_type: sharePayload.payload.context.assessment_type,
            },
          };
          return navigate("/rater", state);
        } else {
          ShareCodeService.getPlanShareCode(
            sharePayload.payload.context.plan_id
          )
            .then((shareCode) => {
              let state = {
                state: {
                  purl_id: sharePayload.payload.context.purl_id,
                  plan_id: sharePayload.payload.context.plan_id,
                  share_id: shareId,
                  public_share_id: shareCode.public,
                },
              };
              return navigate(redirectPath, state);
            })
            .catch(() => {
              let state = {
                state: {
                  purl_id: sharePayload.payload.context.purl_id,
                  plan_id: sharePayload.payload.context.plan_id,
                  share_id: shareId,
                },
              };
              return navigate(redirectPath, state);
            });
        }
      })
      .catch(() => {
        showNotification(t("notifications.shareCode.getShareCodeError"), ERROR);
      });
  }, [showNotification]);
};

export default Share;
